<div class="cashin-card w-100 p-medium radius-medium surface-back gap-medium d-flex flex-column">
  <div class="d-flex justify-content-space-between align-items-center">
    <div class="d-flex wallet-description justify-content-center align-items-center">
      <span class="b-2"> قابل برداشت </span>

      <ngx-button
        [mode]="'icon-only'"
        [style]="'link'"
        [size]="'small'"
        [leftIcon]="{
          name: 'question-mark-circle',
        }"
        [ngxTooltip]="'این موجودی شامل دارایی آزاد و سود تخصیص داده شده به کل موجودی' + walletName() + ' شما است.'"
        [tooltipPosition]="'top-left'"
        [disableArrow]="true"
        [tooltipType]="'click'"
        [closeTimeout]="3000"
      />
    </div>
    <div class="d-flex gap-tiny align-items-center">
      <span class="st-8">{{ withdrawalBalance() | thousands }}</span>
      <span class="c-2 is-currency">ریال</span>
    </div>
  </div>
  <div class="d-flex justify-content-space-between align-items-center">
    <div class="d-flex wallet-description justify-content-center align-items-center">
      <span class="b-2"> غیرقابل برداشت </span>

      <ngx-button
        [mode]="'icon-only'"
        [style]="'link'"
        [size]="'small'"
        [leftIcon]="{
          name: 'question-mark-circle',
        }"
        [ngxTooltip]="'این موجودی شامل دارایی مسدود شده شما برای دریافت اعتبار ۴ قسطه است.'"
        [tooltipPosition]="'top-left'"
        [disableArrow]="true"
        [tooltipType]="'click'"
        [closeTimeout]="3000"
      />
    </div>
    <div class="d-flex gap-tiny align-items-center">
      <span class="st-8">{{ uncollectible() | thousands }}</span>
      <span class="c-2 is-currency">ریال</span>
    </div>
  </div>
</div>
